export const commonInitialValues = {
  type: 1,
  category: "CustomPep",
  addresses: [{
    region: '',
    city: '',
    countryId: undefined,
    postalCode: '',
    streetNumber: '',
  }],
  name: {
    fullName: '', firstName: '', middleName: '', lastName: '',
  },
  nationalityId: undefined,
  comment: '',
};

export const legalEntityInitialValues = {
  addresses: [{
    headquaters: '',
    countryId: undefined,
  }],
  identifications: [{
    number: '',
    type: 'bulstat',
  }],
  companyType: '',
};

export const naturalPersonInitialValues = {
  birthDate: '',
  identifications: [{
    number: '',
    type: 'passport',
  }],
  addresses: [{
    addressOfResidence: '',
    countryId: undefined,
  }],
  isPolitician: '',
};


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/upsert-watch-list-entry-form/initial-values/initialValues.js